import { Component, OnInit } from '@angular/core';
// import { TimesheetApprovalsService } from '../timesheet-approvals.service';
import { DashboardEmployeeService } from '../dashboard-employee/dashboard-employee.service';
import { SessionStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rejected-timesheet-details',
  templateUrl: './rejected-timesheet-details.component.html',
  styleUrls: ['./rejected-timesheet-details.component.css']
})
export class RejectedTimesheetDetailsComponent implements OnInit {
  @SessionStorage() public config;
  public rejectedList: any = [];
  public dateRange: any = [];
  public daysList: any = [];
  public temporaryList: any = [];
  public weekNumber: any;

  constructor(
    private dashboardEmployeeService: DashboardEmployeeService,
    public router: Router
  ) { }

  ngOnInit() {
    this.rejectedTimesheetList();
  }

  /**function to list rejected timesheet */
  rejectedTimesheetList() {
    this.rejectedList = [];
    this.dashboardEmployeeService.getEmployeesDetails().subscribe(
      (data) => {
        if (data.payload.rejectedTimesheetList) {
          data.payload.rejectedTimesheetList.forEach((value, i) => {
            this.daysList[i] = [];
            this.temporaryList.push(value);
            this.rejectedList.push(value);
            const year = new Date().getFullYear();
            const week = value.weekNumber;
            const n1 = this.getStartDateWeek(week, value.timesheetList[0].dateDetails.Year); // change year variable
            const n2 = this.getEndDateWeek(week, value.timesheetList[0].dateDetails.Year); // change year variable
            this.dateRange.push(n1 + ' - ' + n2);
            value.timesheetList.forEach(element => {
              const date = element.dateDetails.date;
              const dayOfWeek = new Date(date).getDay();
              const days = (isNaN(dayOfWeek)) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
              if (!this.daysList[i].includes(days)) {
                this.daysList[i].push(days);
              }
            });
          });
        }
      }
    );
  }

  /**function to get start date of the week */
  getStartDateWeek(w, y) {
    const checkDate = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = checkDate.getDay();
    const weekStart = checkDate;
    if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit === 'aps') {
      if (dow <= 4) {
        weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 1);
      } else {
        weekStart.setDate(checkDate.getDate() + 9 - checkDate.getDay());
      }
    } else {
      if (dow <= 4) {
        weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 0);
      } else {
        weekStart.setDate(checkDate.getDate() + 8 - checkDate.getDay());
      }
    }
    return weekStart.toLocaleDateString();
  }

   /**function to get end date of the week */
  getEndDateWeek(w, y) {
    const checkDate = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = checkDate.getDay();
    const weekStart = checkDate;

    if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit === 'aps') {
      if (dow <= 4) {
        weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 7);
      } else {
        weekStart.setDate(checkDate.getDate() + 9 - checkDate.getDay());
      }
    } else {
      if (dow <= 4) {
        weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 6);
      } else {
        weekStart.setDate(checkDate.getDate() + 8 - checkDate.getDay());
      }
    }
    return weekStart.toLocaleDateString();
  }

  /**function to timesheet */
  timeSheet(row, weekNumber) {
    const data = {
      'employeenumber': row.userDetails.Empno
    };
    const year = row.timesheetList[0].dateDetails.Year ? row.timesheetList[0].dateDetails.Year : new Date().getFullYear();
    this.dashboardEmployeeService.setSelectedRowData(data, weekNumber, year);
    this.router.navigate(['employee/timesheet-entry']);
  }

}



// WEBPACK FOOTER //
// ./src/app/employee/rejected-timesheet-details/rejected-timesheet-details.component.ts